module.exports = __webpack_public_path__ + "img/icon-toggle-en.2572a9d6.svg";